import React from "react";
import bizLogo from "../../assets/biz-consultancy-logo.png";
import { MeetingDetailsScreen } from "../MeetingDetailsScreen";

export function JoinScreen({ participantName, setParticipantName, onStartMeeting }) {
  return (
    <div className="biz-shell">
      <div className="pointer-events-none absolute inset-0 biz-grid-overlay" aria-hidden />
      <div
        className="pointer-events-none absolute -left-24 top-24 h-72 w-72 rounded-full bg-biz-yellow/20 blur-3xl animate-pulseSoft"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -right-16 bottom-10 h-80 w-80 rounded-full bg-white/10 blur-3xl animate-float"
        aria-hidden
      />

      <div className="relative z-10 mx-auto flex min-h-[100dvh] w-full max-w-6xl flex-col px-4 py-6 sm:px-6 lg:px-10 lg:py-10">
        <header className="mb-8 flex items-center justify-between animate-fadeUp sm:mb-10">
          <div className="flex items-center gap-3">
            <img
              src={bizLogo}
              alt="BIZ Consultancy"
              className="h-11 w-11 rounded-xl object-cover shadow-soft ring-1 ring-white/20 sm:h-12 sm:w-12"
            />
            <div>
              <p className="font-sans text-sm font-semibold tracking-wide text-white">
                BIZ Consultancy
              </p>
              <p className="text-xs text-white/60">Meeting Platform</p>
            </div>
          </div>
          <a
            href="https://www.bizconsultancy.iid.org.in/"
            target="_blank"
            rel="noreferrer"
            className="hidden rounded-full border border-white/20 px-4 py-2 text-xs font-medium text-white/90 transition hover:bg-white/10 sm:inline-flex"
          >
            bizconsultancy.iid.org.in
          </a>
        </header>

        <main className="grid flex-1 items-center gap-10 lg:grid-cols-12 lg:gap-14">
          <section className="lg:col-span-6 animate-fadeUp">
            <p className="font-display text-5xl font-semibold tracking-tight text-white sm:text-6xl lg:text-[4.25rem]">
              BIZ
              <span className="mt-1 block text-[0.72em] font-medium text-biz-yellow">
                Consultancy
              </span>
            </p>
            <p className="mt-6 max-w-sm font-sans text-lg leading-relaxed text-white/75">
              Secure meetings for consultations, client calls, and team syncs.
            </p>
          </section>

          <section className="lg:col-span-6 animate-fadeUpDelay">
            <div className="biz-panel mx-auto w-full max-w-md p-6 sm:p-8">
              <MeetingDetailsScreen
                participantName={participantName}
                setParticipantName={setParticipantName}
                onStartMeeting={onStartMeeting}
              />
            </div>
            <p className="mt-4 text-center text-xs text-white/45">
              By joining you agree to use this space professionally.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
}
